// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ideoZ","content":"styles_content__3qtzp","tableWrap":"styles_tableWrap__13kKX"};